import Joi from 'joi';

import { LateFeeTypeEnum } from '../../enums/late-fee-type.enum';

/**
 * Schema for late return policy config validation
 */
export const lateReturnConfigSchema = () =>
	Joi.object({
		gracePeriodMinutes: Joi.number().min(0).integer().allow(null).optional(),
		lateFeeType: Joi.string()
			.valid(...Object.values(LateFeeTypeEnum))
			.required(),

		chargePerHourLate: Joi.number().min(0).allow(null).optional(),
		chargePerDayLate: Joi.number().min(0).allow(null).optional(),
		flatLateFee: Joi.number().min(0).allow(null).optional(),
		percentageOfRental: Joi.number().min(0).max(100).allow(null).optional(),
		maximumLateFee: Joi.number().min(0).allow(null).optional(),
	})
		.unknown(false)
		.custom((value, helpers) => {
			if (
				value.lateFeeType === LateFeeTypeEnum.PER_HOUR &&
				value.chargePerHourLate == null
			) {
				return helpers.error('any.custom', {
					message: 'chargePerHourLate is required for per_hour late fee',
				});
			}
			if (
				value.lateFeeType === LateFeeTypeEnum.PER_DAY &&
				value.chargePerDayLate == null
			) {
				return helpers.error('any.custom', {
					message: 'chargePerDayLate is required for per_day late fee',
				});
			}
			if (
				value.lateFeeType === LateFeeTypeEnum.FLAT &&
				value.flatLateFee == null
			) {
				return helpers.error('any.custom', {
					message: 'flatLateFee is required for flat late fee',
				});
			}
			if (
				value.lateFeeType === LateFeeTypeEnum.PERCENTAGE &&
				value.percentageOfRental == null
			) {
				return helpers.error('any.custom', {
					message: 'percentageOfRental is required for percentage late fee',
				});
			}
			return value;
		});
